<template>
  <div id="content" class="preparebox">
    <div class="sectionName">{{sectionName}}</div>
    <div class="backdetail" @click="backDetail()">
      <Icon type="ios-arrow-back" />返回</div>
    <Tabs type="card" :value="tabName" @on-click="choseTab">
      <TabPane :label="'微课('+ prepareData.videoNum +')'" name="1"></TabPane>
      <TabPane :label="'习题 ('+prepareData.exercisesNum+')'" name="2"></TabPane>
      <TabPane :label="'PPT ('+prepareData.pptNum+')'" name="3"></TabPane>
      <TabPane :label="'学案 ('+prepareData.questionNum+')'" name="4"></TabPane>
      <TabPane :label="'其他资源 ('+prepareData.otherNum+')'" name="5"></TabPane>
    </Tabs>
    <prepare-video v-if="prepareData.type == 1" v-bind:prepareData="prepareData" @showPlayer="showPlayer"></prepare-video>
    <prepare-exercises v-else-if="prepareData.type == 2" v-bind:prepareData="prepareData"></prepare-exercises>
    <prepare-ppt v-else-if="prepareData.type == 3" v-bind:prepareData="prepareData"></prepare-ppt>
    <prepare-question v-else-if="prepareData.type == 4" v-bind:prepareData="prepareData"></prepare-question>
    <prepare-other v-else-if="prepareData.type == 5" v-bind:prepareData="prepareData"></prepare-other>
    <video-player v-if="isPlayer" @closePlayer="closePlayer"></video-player>
  </div>

</template>
<script>
  import PrepareVideo from '../PrepareDetail/PrepareVideo.vue';
  import PrepareExercises from '../PrepareDetail/PrepareExercises.vue';
  import PreparePpt from '../PrepareDetail/PreparePpt.vue';
  import PrepareQuestion from '../PrepareDetail/PrepareQuestion.vue';
  import PrepareOther from '../PrepareDetail/PrepareOther.vue';
  import VideoPlayer from '../videoPlayer/viderPlayer.vue'
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    // name:'PackagePrepare',
    data() {
      return {
        urlHttp: '/testIp',
        tabName: '1',
        prepareData: {},
        packageId: null,
        chapterId: 0,
        lectureId: 0,
        sectionId: 0,
        videoNum: 0,
        exercisesNum: 0,
        pptNum: 0,
        questionNum: 0,
        otherNum: 0,
        isPlayer: false,
        sectionName: '',
        isBack:false
      }
    },
    // watch: {
    //   prepareData: {
    //     handler: function(newVal) {
    //       this.prepareData = newVal
    //     },
    //     deep: true
    //   }


    // },
    mounted() {
      let that = this;

      bus.$off('prepareData');
      bus.$on('prepareData', function(msg) {
        that.prepareData = msg;
        //console.log(that.prepareData, "课")
        that.tabName = that.prepareData.type.toString();
        that.updateSectionById(that.prepareData.sectionId);
      })
    },
    methods: {
      //获取讲节名称
      updateSectionById(sectionId) {
        let that = this;
        const url =  '/axt-resources/package_prepare/querySectionById/' + sectionId;
        api.getListAPI(url).then(res => {
          //console.log('年纪', res)
          //数据处理
          that.sectionName = res.data.data.name;
          // console.log('data',res.data.data)
        }).catch(err => {
          console.log(err)
        })
      },
      //切换tab
      choseTab(name) {
        //console.log('name', name)
        const that = this;
        this.tabName = name;
        if (name == 1) {
          that.prepareData.type = 1;
         // console.log(that.prepareData)
        }
        if (name == 2) {
          that.prepareData.type = 2;
         // console.log(that.prepareData)
        }
        if (name == 3) {
          that.prepareData.type = 3;
         // console.log(that.prepareData)
        }
        if (name == 4) {
          that.prepareData.type = 4;
         // console.log(that.prepareData)
        }
        if (name == 5) {
          that.prepareData.type = 5;
         // console.log(that.prepareData)
        }
      },
      showPlayer(obj) {
        this.isPlayer = obj; //打开播放器  ture
      },
      closePlayer(obj) {
        this.isPlayer = obj; //关闭播放器 false
      },
      backDetail(){
         this.$emit('isBack',false);
      }

    },
    components: {
      PrepareVideo,
      PrepareExercises,
      PreparePpt,
      PrepareQuestion,
      PrepareOther,
      VideoPlayer
    }
  }
</script>

<style>
  .sectionName {
    text-align: left;
    font-size: 22px;
    color: #525A6F;
    font-weight: 500;
    margin-bottom: 10px;
    height: 40px;
  }

  #content.preparebox {
    position: relative;
    margin-top: 30px;
    min-height: 750px;
    padding-bottom: 40px;
  }

  .backdetail {
    float: right;
    position: absolute;
    right: 0px;
    top: 50px;
    font-size: 14px;
    z-index: 10;
    cursor: pointer;
  }

  .backdetail:hover {
    color: #2d8cf0;
  }
</style>



// WEBPACK FOOTER //
// src/components/PackagePrepare/PackagePrepare.vue